<template>
  <div
    id="plvIaLottery"
    ref="container"
    class="plv-ia-app plv-ia-lottery-new"
  >
    <loading v-if="loading"/>
    <!--    开始抽奖表单页-->
    <lottery-start
      v-show="currentStep === step.start"
      ref="lotteryStart"
      :lang="lang"
      :core="core"
      :max-winners-digit="maxWinnersDigit"
      :max-winners="maxWinners"
      :is-restricted-window="isRestrictedWindow"
      :is-subsidiary-Room="isSubsidiaryRoom"
      :history-prize-name="historyPrizeName"
      :lottery-template="lotteryTemplate"
      :lottery-card-list="lotteryCardList"
      @create-lottery="createLottery"
      @change-page="changePage"
      @reset-template="resetTemplate"
    />
    <!-- 选择模板抽奖页-->
    <lottery-template-list
      v-if="currentStep === step.lotteryTemplate"
      :core="core"
      :lang="lang"
      :lotterying-status="lotteryingStatus"
      @choose-template="chooseTemplate"
      @back="currentStep = step.start"
    />

    <!--    活动中抽奖卡片页-->
    <LotteryCardList
      v-if="currentStep === step.lotteryCardList"
      :core="core"
      :lang="lang"
      :lottery-card-list="lotteryCardList"
      :lotterying-status="lotteryingStatus"
      @change-page="changePage"
      @continue-lottery="continueLottery"
      @scroll-loader="getLotteryCardList"
      @reset-lottery-card-list="resetLotteryCardList"
    />

    <LotteryWinner
      v-if="currentStep === step.lotteryResult"
      :core="core"
      :lang="lang"
      :lottery-record="lotteryRecord"
      @close-lottery="closeLottery"
    />
  </div>
</template>

<script>
import commonMixin from '@/apps/app-mixin';
import Locale from '@/mixins/locale';
import LotteryStart from './LotteryStart';
import LotteryTemplateList from './LotteryTemplateList';
import LotteryCardList from './LotteryCardList';
import LotteryWinner from './LotteryWinner';
import { get, set } from '@polyv/utils/src/cookie';
import Loading from '../../components/loading/Loading';

const step = {
  start: 'start', // 开始抽奖，表单页
  lotteryTemplate: 'lotteryTemplate', // 选择抽奖活动页
  lotteryCardList: 'lotteryCardList', // 抽奖活动中，活动列表页
  lotteryResult: 'lotteryResult' // 中奖结果
};

export default {
  name: 'LotteryNew',
  components: {
    LotteryStart,
    LotteryTemplateList,
    LotteryCardList,
    LotteryWinner,
    Loading
  },
  mixins: [commonMixin, Locale],
  props: {
    /**
     * 最大中奖人数位数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinnersDigit: {
      type: Number,
      default: 3
    },
    core: {
      type: Object,
    },
    /**
     * 弹窗大小是否受限。
     * 如云直播客户端中打开抽奖时，窗口大小固定，窗口以外的内容无法显示。
     */
    isRestrictedWindow: {
      type: Boolean,
      default: false,
    },
    /**
     * 最大中奖人数。
     * 如有设置 maxWinners 为非 0 整数时则忽略 maxWinnersDigit 。
     */
    maxWinners: {
      type: Number,
      default: 0,
    },
    /**  直播状态 */
    liveStatus: Boolean,
    /** 是否开启多房间 */
    isSubsidiaryRoom: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      step,
      loading: false,
      currentStep: step.start,
      isFetchingStartApi: false,
      waitingFetchWinners: false,
      historyPrizeName: [],
      lotteryTemplate: null,
      lotteryRecord: null,

      lotteryCardTotalPages: null, // 抽奖活动总页数
      lotteryCardList: [], // 抽奖活动列表
      lotteryCardPage: 1, // 抽奖活动页数
      lotteryingStatus: { // 抽奖中状态
        conditionLotteryStatus: false,
        lotteryStatus: false
      }
    };
  },
  watch: {
    lotteryCardList: {
      handler() {
        // 无条件抽奖，二次结束状态未完成情况下，跳转结果页
        this.checkLotteryList();
      },
      immediate: true
    }
  },
  computed: {
    // 发起中抽奖列表
    lotteryingList() {
      // 抽奖状态，waiting未开始、start进行中。
      const statusArray = ['wait', 'start'];
      // 无条件抽奖状态，end已结束、lottery已开奖 、finish已完成; 当finish时，整个抽奖状态才完成
      const noneTypeArray = ['end', 'lottery'];
      const list = [];
      const { lotteryCardList } = this;
      for (const i in this.lotteryCardList) {
        // 条件和非条件最多存在一种
        if (list.length > 2) {
          break;
        }
        if (statusArray.includes(this.lotteryCardList[i].status)) {
          list.push(this.lotteryCardList[i]);
          continue;
        }
        if (lotteryCardList.conditionType === 'none' && noneTypeArray.includes(this.lotteryCardList[i].status)) {
          list.push(this.lotteryCardList[i]);
        }
      }
      return list;
    },
  },
  created() {
    this.loading = true;
    this.afterCoreInit();
  },
  beforeDestroy() {
    this.core.off('handleConditionLotteryEnd', this.resetLotteryCardList);
    this.core.off('handleConditionLotteryStart', this.resetLotteryCardList);
  },
  methods: {
    async afterCoreInit() {
      // 获取旧版抽奖状态
      this.core.on('handleConditionLotteryEnd', this.resetLotteryCardList);
      this.core.on('handleConditionLotteryStart', this.resetLotteryCardList);
      await this.getLotteryStatus();
      await this.initLotteryCardList();
      this.initHistoryPrize();
    },

    // 获取抽奖
    async getLotteryStatus() {
      try {
        this.lotteryingStatus = await this.core.getLotteryStatus();
      } catch (e) {
        throw new Error(e);
      }
    },

    // 初始化活动抽奖列表
    async initLotteryCardList() {
      if (this.core) {
        this.lotteryCardList = [];
        this.lotteryCardTotalPages = null;
        this.lotteryCardPage = 1;
        await this.getLotteryCardList();
        if (this.lotteryCardList.length > 0) {
          this.currentStep = this.step.lotteryCardList;
        }
        this.$nextTick(() => {
          this.loading = false;
        });
      }
    },

    // 获取活动抽奖列表
    async getLotteryCardList() {
      const { lotteryCardTotalPages, lotteryCardPage } = this;
      if (this.fetchLotteryCard || (lotteryCardTotalPages && lotteryCardPage > lotteryCardTotalPages)) return;
      this.fetchLotteryCard = true;
      try {
        const res = await this.core.searchLotteryCardList(lotteryCardPage);
        this.lotteryCardList = this.lotteryCardList.concat(res.contents);
        this.lotteryCardTotalPages = res.totalPages;
        this.lotteryCardPage++;
      } catch (e) {
        throw new Error(e);
      }
      this.fetchLotteryCard = false;
    },
    // 创建抽奖
    async createLottery(params) {
      const options = JSON.parse(JSON.stringify(params));
      if (!this.liveStatus) {
        this.$iaMessage.default(this.t('plvIA.lottery.startLiveFirst'));
        return false;
      }
      if (this.isFetchingStartApi) {
        return;
      }
      this.isFetchingStartApi = true;
      options.receiveInfo.forEach(item => {
        if (item.required === undefined) {
          item.required = false;
        }
      });
      try {
        // 条件抽奖
        if (this.lotteryTemplate?.conditionType !== 'none') {
          options.formInfo = options.receiveInfo;
        }
        await this.core.lotteryStart(options);
        if (this.lotteryTemplate) {
          this.lotteryingStatus.conditionLotteryStatus = true;
        } else {
          this.lotteryingStatus.lotteryStatus = true;
        }
        this.setCookie(options.prizeName);
        this.$refs.lotteryStart.reset();
        await this.resetLotteryCardList();
        this.changePage({ page: this.step.lotteryCardList });
        this.getLotteryStatus();
      } catch (error) {
        this.$iaMessage.default(error.message);
      } finally {
        this.isFetchingStartApi = false;
      }
    },
    async resetLotteryCardList() {
      this.lotteryCardPage = 1;
      this.lotteryCardList = [];
      this.lotteryCardTotalPages = null;
      await this.getLotteryCardList();
    },

    setCookie(prizeName) {
      if (this.historyPrizeName.some(item => item === prizeName)) return;
      this.historyPrizeName.unshift(prizeName);
      if (this.historyPrizeName.length >= 10) {
        this.historyPrizeName = this.historyPrizeName.slice(0, 10);
      }
      set('prizeHis', this.historyPrizeName);
    },
    initHistoryPrize() {
      const prizeHis = get('prizeHis');
      if (prizeHis) this.historyPrizeName = prizeHis.split(',');
    },

    // 选择模板
    chooseTemplate(item) {
      this.currentStep = step.start;
      this.lotteryTemplate = item;
    },
    changePage({ page, lotteryRecord }) {
      this.lotteryRecord = null;
      if (page === this.step.lotteryResult) {
        this.lotteryRecord = lotteryRecord;
      } else if (page === this.step.lotteryCardList) {
        this.resetLotteryCardList();
      } else if (page === this.step.start) {
        this.getLotteryStatus();
      }
      this.currentStep = page;
    },
    continueLottery() {
      this.$refs.lotteryStart.resetTemplate();
      this.changePage({ page: this.step.start });
    },
    resetTemplate() {
      this.lotteryTemplate = null;
    },
    async closeLottery() {
      await this.getLotteryStatus();
      this.changePage({ page: this.step.lotteryCardList });
    },
    // 判断抽奖列表中是否有二次结束
    checkLotteryList() {
      const { lotteryCardList } = this;
      const target = lotteryCardList.find(item => item.conditionType === 'none' && item.status === 'end');
      if (target) {
        this.$nextTick(() => {
          this.changePage({ page: 'lotteryResult', lotteryRecord: target });
        });
      }
    }
  }
};
</script>

<style lang="scss">
.plv-ia-lottery-new * {
  box-sizing: border-box;
}
.plv-ia-lottery input[type='text'] {
  color: #333;
  font-size: 14px;

  &::-webkit-input-placeholder {
    color: #9e9e9e;
  }
  &.plv-ia-wrong-input {
    border: 1px solid #ff5722 !important;
    background: #ffe9e9 !important;
    &::-webkit-input-placeholder {
      color: #333 !important;
    }
  }
}
.plv-ia-lottery-new {
  position: relative;
  color: #333;
  width: 100%;
  overflow: auto;
  margin: 0 auto;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
  .plv-ia__lottery-btn-group {
    margin: 24px 0;
    // margin-bottom: 36px;
    text-align: center;
    .plv-ia-lottery-btn {
      height: 32px;
      line-height: 32px;
      padding: 0 20px;
      background: #2196f3;
      font-size: 14px;
      color: #ffffff;
      border-radius: 18px;
      border: none;
      outline: none;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.9;
      }
    }

    .plv-ia-lottery-btn--cancel {
      color: #666666 !important;
      border: 1px solid #EBEEF5;
      background: #ffffff;
    }

    .plv-ia-lottery-btn--back {
      color: #2196F3 !important;
      border: 1px solid #2196F3;
      background: #ffffff;
    }
  }
}

</style>
